import { request } from '../ServiceBase';

/**
 * Realiza o login do fornecedor
 * @param {object} data Objeto JSON.
 * @param {string} data.email Email do usuário.
 * @param {string} data.senha senha do usuário.
 */
const login = data => request({ url: 'autenticacao', method: 'POST', data });

/**
 * Envia pedido de reset de senha
 * @param {object} data Objeto JSON.
 * @param {string} data.email Email do usuário.
 * @param {string} data.confirmacaoEmail Confirmação de e-mail do usuário.
 */
const recoverPassword = data => request({ url: 'autenticacao/esqueci-senha', method: 'POST', data });

/**
 * Realiza o reset do fornecedor com token fornecido
 * @param {object} data Objeto JSON.
 * @param {string} data.token Token de validação de reset.
 * @param {string} data.senha Nova senha a ser cadastrada.
 * @param {string} data.confirmacaoSenha Confirmação de nova senha.
 */
const resetPassword = data => request({ url: 'autenticacao/resetar-senha', method: 'POST', data });

/**
 * Realiza a redefinição de senha do fornecedor
 * @param {object} data Objeto JSON.
 * @param {string} data.senhaAtual Senha atual do usuário.
 * @param {string} data.novaSenha Nova senha a ser cadastrada.
 * @param {string} data.confirmacaoNovaSenha Confirmação de nova senha.
 * @param {string?} data.token Token de validação de reset.
 */
const resetPasswordRequest = (data, options) =>
	request({ url: 'autenticacao/redefinir-senha', method: 'POST', data, ...options });

const cookie = {
	isSupported: !!navigator.cookieEnabled,
	exists: name => {
		return document.cookie.indexOf(`${name}=`) + 1;
	},
	write: (name, value, expiresDate, path, domain, secure) => {
		const expires =
			expiresDate instanceof Date
				? expiresDate.toGMTString()
				: typeof expiresDate === 'number' && new Date(+new Date() + expiresDate * 1e3).toGMTString();
		const r = [`${name}=${escape(value)}`];
		const k = { expires, path, domain };
		Object.keys(k).forEach(key => {
			if (k[key]) r.push(`${k}=${k[key]}`);
		});

		if (secure) r.push('secure');
		document.cookie = r.join(';');
		return true;
	},
	read: name => {
		const c = document.cookie;
		let s = cookie.exists(name);
		return s ? unescape(c.substring((s += name.length), (c.indexOf(';', s) + 1 || c.length + 1) - 1)) : '';
	},
	remove: (name, path, domain) => {
		return cookie.exists(name) && cookie.write(name, '', new Date(0), path, domain);
	},
};

/**
 * Grava um token no localStorage ou cookie dependendo do parâmetro isSession
 * @param {string} name Nome do token
 * @param {string} value Valor do token
 * @param {boolean?} isSession Valida se o token é temporário
 */
const setToken = (name, value, isSession) => {
	if (isSession) {
		cookie.write(name, value);
		localStorage.removeItem(name);
	} else {
		cookie.remove(name);
		localStorage.setItem(name, value);
	}
};

/**
 * Retorna token do localStorage ou cookie
 * @param {string} name Nome do token
 */
const getToken = name => {
	return localStorage.getItem(name) || cookie.read(name);
};

/**
 * Remove o token do localStorage ou cookie
 * @param {string} name Nome do token
 */
const removeToken = name => {
	localStorage.removeItem(name);
	cookie.remove(name);
};

const LoginService = {
	login,
	recoverPassword,
	resetPassword,
	resetPasswordRequest,
	setToken,
	getToken,
	removeToken,
};

export default LoginService;
